import { PotentialChildCustomersResponseSchema } from '@vy/api-definition';
import type { PotentialChildCustomersResponse } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function usePotentialCustomerChildren(
  options?: CustomUseQueryOptions<PotentialChildCustomersResponse>,
) {
  const getPotentialCustomerChildren = useQuery(
    queryKeys.customer('customer-children'),
    async () => {
      const api = getPrivateApi();
      const getPotentialCustomerChildrenResponse = await api.getPotentialChildCustomers();

      return PotentialChildCustomersResponseSchema.parse(getPotentialCustomerChildrenResponse);
    },
    {
      refetchOnWindowFocus: true,
      ...options,
    },
  );

  return getPotentialCustomerChildren;
}
